export type EmployeeUnitExtractRow = {
  emp_id?: number;
  emp_name: string;
  role: string;
  shift?: string;
  total_units: number;
  design_units_live: number;
  qc_units_live: number;
  design_units_redesign: number;
  qc_units_redesign: number;
  design_units_internal_live: number;
  qc_units_internal_live: number;
  design_units_internal_redesign: number;
  qc_units_internal_redesign: number;
  files_units?: number;
  model_units?: number;
};

export const EMPLOYEE_UNIT_COLUMNS: { key: keyof EmployeeUnitExtractRow | "shift"; label: string }[] = [
  { key: "emp_name", label: "Employee" },
  { key: "role", label: "Role" },
  { key: "shift", label: "Shift" },
  { key: "total_units", label: "Total" },
  { key: "design_units_live", label: "Design Live" },
  { key: "qc_units_live", label: "QC Live" },
  { key: "design_units_redesign", label: "Design Redesign" },
  { key: "qc_units_redesign", label: "QC Redesign" },
  { key: "design_units_internal_live", label: "Design IL" },
  { key: "qc_units_internal_live", label: "QC IL" },
  { key: "design_units_internal_redesign", label: "Design IR" },
  { key: "qc_units_internal_redesign", label: "QC IR" },
  { key: "files_units", label: "Files" },
  { key: "model_units", label: "Model" },
];

const n = (v: unknown) => Number(v || 0);

const cellValue = (row: EmployeeUnitExtractRow, key: string) => {
  if (key === "emp_name" || key === "role" || key === "shift") {
    return String(row[key as keyof EmployeeUnitExtractRow] || "");
  }
  return n(row[key as keyof EmployeeUnitExtractRow]);
};

export function employeeUnitsExcelRows(rows: EmployeeUnitExtractRow[]) {
  const body = rows.map((row) =>
    Object.fromEntries(
      EMPLOYEE_UNIT_COLUMNS.map(({ key, label }) => [label, cellValue(row, String(key))]),
    ),
  );

  const totals = Object.fromEntries(
    EMPLOYEE_UNIT_COLUMNS.map(({ key, label }) => {
      if (key === "emp_name") return [label, "TOTAL"];
      if (key === "role" || key === "shift") return [label, ""];
      return [label, rows.reduce((sum, row) => sum + n(row[key]), 0)];
    }),
  );

  return [...body, totals];
}
